<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Royal Mail Door Drops</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-80">
            <div class="component__columns-2 layout__margin-20-0">
                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/flyers.jpg" class="layout__width-90 layout__padding__bottom-25px">
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <h3 class="text__colour-teal text__style-bold-900">92% of people read door drops delivered to their home<sup>1</sup>.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Want to boost your sales with effective, carefully targeted mail?<br>
                    Let Ravensworth help you achieve a wider reach with Royal Mail Door Drops. This cost effective solution allows you to target the right audience and produce effective messaging, planning ahead ensures that you stay ahead of the competition*.
                </div>

                <div class="text__size-16 text__colour-grey text__line-height-20px">
                    Door drops are a cost-effective way to get your leaflets and flyers into customers’ hands. 67% of people have been prompted to buy after receiving a door drop directly to through their door<sup>1</sup>.
                </div>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Ravensworth can help you reach the right people, with precise targeting by location or demographic. This is a great alternative to direct mail as you can use door drops to get your message into relevant homes across the UK, without the use of using personal data.
                </div>

                <div class="text__size-16 text__line-height-20px">
                    Door drops have the physical power to drive an actual response sometimes lost on a flooded digital marketplace. Ravensworth is here to help brands and agencies get the most from marketing efforts, contact us today to discuss further.
                </div>

                <div class="layout__padding-20-0">
                    <el-button class="layout__width-230px button-red layout__margin__right-20px" v-on:click="contactUs()">Contact us
                    </el-button>
                </div>

                <div class="text__size-12">
                    <sup>1</sup>Royal Mail MarketReach, Iluminas 2014
                </div>
                <div class="text__size-12">
                    *Royal Mail does require at least six weeks notice to secure your dates therefore it is vital to plan ahead.
                </div>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/web-banners">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Web Banners</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/microsites">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Microsites</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png" class="layout__width-100">
                        <div class="component__product__subtitles">
                            <div>Animated Brochure</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import Router from '../../router';

    export default {
        name: "SM",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>